import React, { Component, PropTypes } from 'react';

class App extends Component {
  static propTypes = {
    // Injected by React Router
    children: PropTypes.node
  };

  // TODO: remove this when app is no longer called with token as querystring
  componentWillMount() {
    const accessToken = this.props.location.query.accessToken;
    if (accessToken) {
      window.sessionStorage.accessToken = accessToken;
    }
  }

  render() {
    const { children } = this.props;
    return (
      <div>
        {children}
      </div>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/app/containers/App.js